module.exports = __webpack_public_path__ + "img/9788957982754.0875c7bb.jpg";